import { forwardRef, PropsWithChildren } from 'react';

import { styled } from 'styled-components';

import { auroraCheckIconUrl } from 'ui/components/Icons/AuroraCheck';

// Src: https://moderncss.dev/pure-css-custom-styled-radio-buttons/
const RadioInput = styled.input(
  ({ theme }) => `
  appearance: none;
  cursor: pointer;
  margin: 0;
  font-size: 24px;
  width: 1em;
  height: 1em;
  border: 0.1em solid ${theme.colors.white2};
  border-radius: 50%;
  display: grid;
  place-content: center;

  &:focus {
    outline: max(2px, 0.1em) solid ${theme.colors.focusOutline};
    outline-offset: max(2px, 0.05em);
  }

  &::before {
    content: "";
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
    background-color: ${theme.colors.helsinkiBlue};

    /* transform for chekced state, with animations */
    transform: scale(0);
    transition: 120ms transform ease-in-out;
  }

  &:checked::before {
    transform: scale(1);
  }
`,
);

const AuroraRadioInput = styled.input(
  () => `
  appearance: none;
  cursor: pointer;
  display: flex;
  width: 24px;
  height: 24px;
  padding: 1px;
  justify-content: center;
  align-items: center;
  border: 2px solid white;
  border-radius: 50%;
  background-color: #2A343C;  

  &:checked {
    border: none;
  }

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #95D1F1;
    background-image: url("${auroraCheckIconUrl}");
    background-repeat: no-repeat;    
    background-position: center;    

    /* transform for checked state, with animations */
    transform: scale(0);
    transition: 120ms transform ease-in-out;
  }

  &:checked::before {
    transform: scale(1);
  }
`,
);

export type RadioButtonProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const RadioButton = forwardRef<HTMLInputElement, PropsWithChildren<RadioButtonProps>>((props, ref) => {
  return <RadioInput type="radio" ref={ref} {...props} />;
});

export const AuroraRadioButton = forwardRef<HTMLInputElement, PropsWithChildren<RadioButtonProps>>((props, ref) => {
  return <AuroraRadioInput type="radio" ref={ref} {...props} />;
});
